import script from "./MediaItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaItem.vue?vue&type=script&lang=ts&setup=true"

import "./MediaItem.vue?vue&type=style&index=0&id=24034c19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24034c19"]])

export default __exports__